import moment from 'moment';

import { i18n } from 'app/i18n';

export class DateUtils {
    public static getDateWithDayOfWeek(date: string): string {
        return moment(date).format(i18n.summary.activationAndInstallation.dateFormat);
    }

    public static isDateInTheFuture(date: string): boolean {
        const today = moment().startOf('day');

        return moment(date).startOf('day').isAfter(today);
    }
}
